import React from "react";
import { useContent } from "../context/ContentContext";

const Stats = () => {
  const { content } = useContent();
  const c = content.company || {};
  const items = [
    { value: c.yearsExp, label: "Yıllık Tecrübe" },
    { value: c.satisfiedCustomers, label: "Mutlu Müşteri" },
    { value: c.totalCoops, label: "Kurulan Kümes" },
    { value: c.totalChickens, label: "Sağlıklı Yarka" },
  ];

  return (
    <section className="py-16 bg-[#b91c1c] relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.04]" style={{
        backgroundImage: "radial-gradient(circle at 25px 25px, white 2px, transparent 0)",
        backgroundSize: "50px 50px"
      }} />
      <div className="relative max-w-7xl mx-auto px-6 grid grid-cols-2 md:grid-cols-4 gap-8">
        {items.map((it, i) => (
          <div key={i} className="text-center group">
            <div className="text-4xl md:text-5xl font-black text-white tracking-tight group-hover:scale-110 transition-transform inline-block">
              {it.value}
            </div>
            <div className="mt-2 text-white/70 text-xs md:text-sm uppercase tracking-[0.2em] font-medium">
              {it.label}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Stats;
